import React, { useState } from "react";
import styled from "styled-components";
import "./style.css";
import fundo from "../../../styles/fundo.svg";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

const Geral = styled.div`
  width: 1000px;
  border: 1px solid #ccc;
  padding: 20px;
  background-color: #fff;
  display: flex;
  align-items: center;
  flex-direction: column;
  
`;
const Table = styled.table`
  width: 980px;
  background-color: #fff;
  padding: 20px 20px;
  box-shadow: 0px 0px 2px #ccc;
  border-radius: 0.5px;
  margin: 5px auto;

`;

export const TdButton = styled.td`
  font-size: 14px;
  font-weight: bold;
  word-break: break-word;
  padding-top: 15px;
  padding-bottom: 5px;
  cursor: pointer;
`;

export const Thead = styled.thead``;

export const Tbody = styled.tbody`
  padding-bottom: 25px; 
`;

export const Tr = styled.tr`
  text-align: center;
  text-decoration: none;
  border: none;
  width: 100%;
  background-color: #fff;
  transition: transform 0.3s;

  &:hover {
    color: black;
    background-color: #f5f5f5;
  }

`;

export const Th = styled.th`
  color: #4f4f4f;
  text-align: start;
  border-bottom: inset;
  padding-bottom: 5px;


`;

export const Td = styled.td`
  word-break: break-word;
  padding-top: 15px;
  padding-bottom: 5px;
  text-align: ${(props) => (props.alignCenter ? "center" : "start")};
  width: ${(props) => (props.width ? props.width : "auto")};
 

`;

export const Td1 = styled.td`
  padding-top: 15px;
  text-align: center;


`;

export const Td2 = styled.td`
  word-break: break-word;
  padding-top: 15px;
  padding-bottom: 5px;
  text-align: ${(props) => (props.alignCenter ? "center" : "start")};
  width: ${(props) => (props.width ? props.width : "auto")};
 
`;

export const Td3 = styled.td`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-around;

  span{
    margin: 0px 5px;
  }

`;



const Div = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  background-color: #fff;
  margin-top: 25px;

  span{
    padding: 0px  10px;
  }

  h2 {
    color: #575757;
  }
`;

const ButtonExport = styled.td`
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
  background-color: #ccc;
  color: white;
  border-radius: 5px;
  width: 50px;
  text-align: center;
  align-items: center;
  height: 20px;
  margin-left: 10px;
  &:hover {
    background-image:url(${fundo});
  }

  
`;

const Grid = ({ onEditTreinamentoPorUsuario, usuariosExata_Treinamento }) => {


  const usuarioFiltrado = usuariosExata_Treinamento.filter(usuario => usuario.cracha == onEditTreinamentoPorUsuario.cracha);


  //--------------------------------------------------------------------------------------------------------------//
  // Ordenando a tabela
  const [sortConfig, setSortConfig] = useState(null);

  const sortedData = [...usuarioFiltrado].sort((a, b) => {
    if (sortConfig !== null) {
      const aValue = a[sortConfig.key];
      const bValue = b[sortConfig.key];

      if (aValue < bValue) {
        return sortConfig.direction === "ascending" ? -1 : 1;
      }
      if (aValue > bValue) {
        return sortConfig.direction === "ascending" ? 1 : -1;
      }
    }
    return 0;
  });

  // Função para Alterar Ordenação
  const onColumnClick = (key) => {
    let direction = "ascending";

    if (sortConfig && sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending";
    }

    setSortConfig({ key, direction });

  };
  //--------------------------------------------------------------------------------------------------------------//

  // Função para obter a classe CSS da coluna ordenada
  const getSortClass = (key) => {
    return sortConfig?.key === key ? "sorted-column" : "";
  };

  // Função para exibir o ícone de ordenação (▲ ou ▼)
  const getSortIcon = (key) => {
    if (sortConfig?.key !== key) return "↕"; // Ícone neutro quando não ordenado
    return sortConfig.direction === "ascending" ? "▲" : "▼";
  };


  //------------------------------------------------------------------------------------------------------------//

  const exportarParaExcel = (dados, cracha, nome) => {
    const dadosFormatados = dados.map(item => ({
      Titulo: item.titulo,
      Data: item.data,
      Situação: item.status === 'I' || item.status === 'P' ? 'Presente' : 'Faltante',
    }));

    // Cria o cabeçalho com crachá e nome
    const cabecalho = [[`${onEditTreinamentoPorUsuario.cracha} - ${onEditTreinamentoPorUsuario.nome}`], []]; // segunda linha em branco

    // Converte os dados formatados para array de arrays (aoa = array of arrays)
    const corpo = XLSX.utils.json_to_sheet(dadosFormatados, { skipHeader: false });

    // Cria a planilha final começando pelo cabeçalho
    const ws = XLSX.utils.aoa_to_sheet(cabecalho);

    // Adiciona os dados da tabela logo após o cabeçalho (a partir da linha 3)
    XLSX.utils.sheet_add_json(ws, dadosFormatados, {
      skipHeader: false,
      origin: -1 // adiciona abaixo do conteúdo existente
    });

    // Cria e exporta o arquivo
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Treinamentos');
    const buffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([buffer], { type: 'application/octet-stream' });
    saveAs(blob, `treinamentos_cracha_${onEditTreinamentoPorUsuario.cracha}.xlsx`);
  };

  return (

    <Geral>

      <Div>
        <h2>{onEditTreinamentoPorUsuario.cracha} - {onEditTreinamentoPorUsuario.nome}</h2>
        <Div style={{ display: 'flex', flexDirection: 'row' }}>
          <p>Exportar: </p>
          <ButtonExport onClick={() => exportarParaExcel(sortedData)}>Excel</ButtonExport>
        </Div>
        <Table >

          <Thead>
            <Tr>
              <Th onClick={() => onColumnClick("titulo")} className={getSortClass("titulo")}>
                Treinamentos/Eventos: {getSortIcon("titulo")}
              </Th>
              <Th onClick={() => onColumnClick("data")} className={getSortClass("data")}>
                Data: {getSortIcon("data")}
              </Th>
              <Th onClick={() => onColumnClick("status")} className={getSortClass("status")}>
                Situação: {getSortIcon("status")}
              </Th>

            </Tr>
          </Thead>
          <Tbody>
            {sortedData
              .map((item, i) => (
                <Tr key={i}>
                  <Td>{item.titulo}</Td> {/* Titulo */}
                  <Td>{item.data}</Td> {/* Data */}
                  <Td>
                    {item.status === 'I' || item.status === 'P' ? 'Presente' : 'Faltante'}
                  </Td>
                </Tr>
              ))}
          </Tbody>


        </Table>

      </Div>


    </Geral>
  );
};


export default Grid;
